import { useIntl } from '@weenat/wintl'
import { useOrgContext } from 'app/orgProvider'
import Text from 'app/src/kit/Text'
import isNil from 'lodash-es/isNil'
import LastUpdateBadge from './LastUpdateBadge'

export interface UpdateInformationProps {
  className?: string
  /**
   * Date of the update in a unix timestamp format
   * @default null
   */
  timestamp: number | null | undefined
  /**
   * Timezone of the ressource
   * @default undefined
   */
  timezone: string | undefined
  /**
   * warning threshold in minutes, used to color the badge
   */
  warningThreshold: number
  /**
   * danger threshold in minutes, used to color the badge
   */
  dangerThreshold: number
  /**
   * Name of the data provider (usually the device technical name)
   */
  name?: string
  /**
   * Provide it to create a link towards the ressource.
   */
  deviceId?: number
}

const UpdateInformation: FC<UpdateInformationProps> = ({
  timestamp = null,
  timezone,
  warningThreshold,
  dangerThreshold,
  className,
  name,
  deviceId
}) => {
  const { t } = useIntl()
  const org = useOrgContext()
  const currentOrgId = org.id

  const informationOrigin = (
    <Text $lineHeight='none' $fontSize='sm' $color={'grayscale.700'}>
      {!isNil(name)
        ? name
        : isNil(timestamp)
          ? t('summaries.metric_providers.none', { capitalize: true })
          : null}
    </Text>
  )

  return (
    <Flex className={className} $alignItems='center' $gap='sm'>
      {!isNil(deviceId) ? (
        <a href={`/farms/${currentOrgId}/admin/devices/${deviceId}`}>{informationOrigin}</a>
      ) : (
        informationOrigin
      )}
      <LastUpdateBadge
        timestamp={timestamp}
        timezone={timezone}
        warningThreshold={warningThreshold}
        dangerThreshold={dangerThreshold}
      />
    </Flex>
  )
}

export default UpdateInformation
